import { combineReducers } from 'redux';
import {
  CRM_PERMISSION_SUCCESS
} from "../action-types/userInfo";

const crmPermission = (state = {}, action) => {
  if (action.type === CRM_PERMISSION_SUCCESS) {
    let crmPerNames = [];
    let crmPerList = action.data.permissions && action.data.permissions.filter(item => item.name === '导入客户' || item.name === '导入联系人') || [];
    crmPerList.length > 0 && crmPerList.map(item => {
      crmPerNames.push(item.name)
    })
    crmPerNames = Array.from(new Set(crmPerNames))
    return { ...state, crmPerList, crmPerNames, features:  action.data.features}
  }
  return state
}

export default combineReducers({
  crmPermission
})
